import React from 'react';
import { motion } from 'framer-motion';
import { smoothScrollTo } from './Button';
interface ImageClickableProps {
  src: string;
  alt: string;
  className?: string;
}
export function ImageClickable({
  src,
  alt,
  className = ''
}: ImageClickableProps) {
  const handleClick = () => {
    smoothScrollTo('oferta', 800);
  };
  return <motion.img whileHover={{
    scale: 1.02
  }} onClick={handleClick} src={src} alt={alt} className={`cursor-pointer rounded-xl shadow-lg ${className}`} data-id="element-143" />;
}